import { render, staticRenderFns } from "./step3_contact.vue?vue&type=template&id=1b7d12dd&scoped=true&"
import script from "./step3_contact.vue?vue&type=script&lang=js&"
export * from "./step3_contact.vue?vue&type=script&lang=js&"
import style0 from "./step3_contact.vue?vue&type=style&index=0&id=1b7d12dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d12dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7d12dd')) {
      api.createRecord('1b7d12dd', component.options)
    } else {
      api.reload('1b7d12dd', component.options)
    }
    module.hot.accept("./step3_contact.vue?vue&type=template&id=1b7d12dd&scoped=true&", function () {
      api.rerender('1b7d12dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Report/step3_contact.vue"
export default component.exports